<template>
  <div>
    <v-layout>
      <v-col cols="3">
        <filter-comp
          :hide_date_filter="true"
          :hide_sort_filter="true"
          :hide_account_filter="true"
          :hide_active_filter="true"
          view="creds"
          @apply_filters="applyFilters($event.filters, $event.active_only)"
        ></filter-comp>
      </v-col>
      <v-col>
        <div v-if="creds">
          <v-data-table
            :headers="headers"
            :items="creds"
            item-key="credentials_id"
            class="elevation-1 row-pointer"
            :loading="loading"
            hide-default-footer
            @click:row="
              viewCredential(
                $event.registered_credentials.credentials_id,
                $event.registered_credentials.account_id
              )
            "
          >
            <template v-slot:top>
              <v-row justify="end">
                <v-btn
                  id="add_credentials"
                  :to="{ name: 'creds-create' }"
                  elevation="4"
                  color="primary"
                  class="ma-4 button_text--text"
                >
                  Add Credentials
                </v-btn>
              </v-row>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <creds-actions
                :credentials="item"
                @delete_credentials="delete_credentials($event.credentials)"
              ></creds-actions>
            </template>

            <template v-slot:footer>
              <div><v-divider></v-divider></div>
              <v-layout justify-end>
                <paging-comp
                  :paging_id="getPagingId()"
                  :has_more="has_more"
                  @next_page="$emit('next_page', { last_id: $event.last_id })"
                  @prev_page="$emit('prev_page', { first_id: $event.first_id })"
                  ref="pagingComp"
                ></paging-comp>
              </v-layout>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-layout>
  </div>
</template>

<style scoped>
.value-pointer {
  cursor: pointer;
}
</style>

<script>
import FilterComp from "@/components/shared/Filter.vue";
import PagingComp from "@/components/shared/Paging.vue";
import CredsActions from "@/components/credentials/CredsActions.vue";
import { mapGetters } from "vuex";

export default {
  props: ["creds", "has_more", "loading"],
  components: {
    FilterComp,
    PagingComp,
    CredsActions,
  },
  data() {
    return {};
  },
  computed: {
    headers() {
      return [
        {
          text: "Credentials ID",
          value: "registered_credentials.credentials_id",
        },
        { text: "Description", value: "registered_credentials.description" },
        { text: "Created", value: "registered_credentials.created" },
        { text: "Modified", value: "registered_credentials.modified" },
        { text: "Actions", value: "actions", sortable: false },
      ];
    },
    ...mapGetters(["user_details", "account_details"]),
  },
  methods: {
    viewCredential(creds_id, account_id) {
      this.$router.push({
        name: "creds-details",
        params: {
          creds_id: creds_id,
          account_id: account_id,
        },
      });
    },

    applyFilters(filters) {
      // reset paging and push query params to router
      this.$refs.pagingComp.refreshPaging();
      this.$router
        .push({
          query: {
            filters: filters,
          },
        })
        .catch(() => {
          // catch redundant path error
        });
    },

    getPagingId() {
      let paging_id = "";
      if (this.creds.length > 0) {
        paging_id =
          this.creds.slice(-1)[0]["registered_credentials"]["credentials_id"];
      }
      return paging_id;
    },

    delete_credentials(credentials) {
      this.$emit("delete_credentials", {
        credentials: credentials,
      });
    },
  },
};
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>

